

const initialInventory = [
    {name: "Hat", image:"/images/hat.jpg", price: 4.99, id: 1, imageNobg: "/images/hat-nobg.png"},
    {name: "Hoodie", image:"/images/hoodie.webp", price: 20, id: 2, imageNobg: "/images/hoodie-nobg.png", paymentLink: "https://buy.stripe.com/7sY8wObomfGX4VMeNkgUM01"},
    {name: "Joggers", image: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/sweatpants.jpg", price: 9.99, id:3, imageNobg: "images/sweatpants-nobg.png"},
    {name: "Bag", image: "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-01.jpg", price: 14.99, id: 4, imageNobg: "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-01.jpg"}
    
]

export const loadData = () => {
    return {
        type: "inventory/loadData",
        payload: initialInventory
    }
}

export const addtoInventory = (item) => {
    return {
        type: "inventory/addtoInventory",
        payload: "item"
    }
}

export const inventoryReducer = (inventory=initialInventory, action) => {
    switch (action.type){
        case ("inventory/loadData"): {
            return action.payload
        }
        case ("inventory/addtoInventory"): {
            return [...inventory, action.payload]
        }
        default: {
            return inventory
        }
    }
}